module.exports = __webpack_public_path__ + "assets/c19eaa5b6c377475cee4b91eeecbd883.ogg";